/**
 * @name 获取sessionStorage的门户map
 */
export var getCurrentPortalCodeObj = function getCurrentPortalCodeObj() {
  var tempCurrentPortalAliasObj = sessionStorage.getItem('currentPortalAliasObj');
  try {
    tempCurrentPortalAliasObj = JSON.parse(tempCurrentPortalAliasObj);
    return tempCurrentPortalAliasObj;
  } catch (error) {
    return {};
  }
};

/**
 * @name 获取url的门户code
 */
export var getPortalCodeFromUrl = function getPortalCodeFromUrl(customInfo) {
  var _location$pathname$sp;
  var _ref = customInfo || {},
    _ref$isGetDomain = _ref.isGetDomain,
    isGetDomain = _ref$isGetDomain === void 0 ? false : _ref$isGetDomain;
  /**当本地origin匹配机构门户pc或者机构门户h5时 开始判断逻辑 */
  var currentAlias = ((_location$pathname$sp = location.pathname.split('/')) === null || _location$pathname$sp === void 0 ? void 0 : _location$pathname$sp[1]) || '';
  if (isGetDomain) {
    // 获取域名信息 直接返回路由中的自定义域名
    return currentAlias;
  }
  var currentPortalCodeObj = getCurrentPortalCodeObj();
  return (currentPortalCodeObj === null || currentPortalCodeObj === void 0 ? void 0 : currentPortalCodeObj[currentAlias]) || '';
};